<template>
  <div class="layout-menu-group-dialog-content">
    <div class="content">
      <Sider
        ref="sider"
        :loading.sync="siderLoading"
        @change="onGroupChange"
        @updateGroup="handleUpdateGroup"
        @update="handleUpdate"
      />
      <ModuleList
        ref="moduleList"
        :activeItem="activeItem"
        :loading.sync="tagLoading"
        :menuIconMap="menuIconMap"
        @move="handleMove"
        @add="handleAdd"
        @update="handleUpdate"
      />
    </div>
    <kye-dialog
      v-bind="dialogOption"
      :showFullScreenButton="false"
      :view.sync="dialogOption.view"
      :class="layoutDialogClass"
      :visible.sync="dialogOption.show"
    >
      <component
        :is="dialogOption.view"
        :dialogData="dialogData"
        :menuGroup="curMenuGroup"
        @updateGroup="handleUpdateGroup"
        @update="handleUpdate"
        @close="closeDialog"
      ></component>
    </kye-dialog>
  </div>
</template>

<script>
  // 弹窗混入
  import dialogMixins from '../../dialog'
  // 左侧内容
  import Sider from './sider/sider.vue'
  // 模块列表
  import ModuleList from './module-list/module-list.vue'
  import AddMenuDialog from '../add-menu-dialog'
  // 移动到分组
  import MoveGroupDialog from './move-group-dialog'
  import {getMenuIcon} from '@/layout/pages/home/common-menu-card/menuIcon'
  export default {
    components: { Sider, ModuleList, AddMenuDialog, MoveGroupDialog },
    mixins: [dialogMixins],
    data() {
      return {
        activeItem: null,
        dialogData: null,
        siderLoading: true,
        tagLoading: true,
        menuIconMap: {},
        layoutDialogClass: ''
      }
    },
    computed: {
      // 转化分组数据
      curMenuGroup() {
        if (!this.activeItem) return null
        return {
          moduleGroupId: this.activeItem.id,
          moduleGroupName: this.activeItem.groupName
        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      // 初始化
      async init() {
        // 取消批量操作状态
        this.$refs.moduleList && this.$refs.moduleList.handleBatchCancel()
        const userId = this.$store.state.user.id
        await this.$refs.sider.initGroupList(userId)
        this.menuIconMap = await getMenuIcon()
      },
      // 分组切换
      onGroupChange(item) {
        this.activeItem = item
        // 取消批量操作状态
        this.$refs.moduleList && this.$refs.moduleList.handleBatchCancel()
      },
      // 移动到
      handleMove(tag) {
        const groupList = this.$refs.sider.list
        this.dialogData = {
          tag,
          groupList
        }
        this.layoutDialogClass = 'layout-move-group-dialog'
        this.showDialog('MoveGroupDialog', '移动分组', '400px')
      },
      // 添加常用
      handleAdd() {
        this.layoutDialogClass = 'layout-add-menu-dialog kye-dialog-dynamic layout-menu-group-child-dialog'
        this.showDialog('AddMenuDialog', '', '1150px')
      },
      // 更新分组（编辑后）
      async handleUpdateGroup(updateGroup) {
        await this.$refs.sider.updateGroup(updateGroup)
        this.$emit('update')
        // 取消批量操作状态
        this.$refs.moduleList && this.$refs.moduleList.handleBatchCancel()
      },
      // 通用更新处理
      async handleUpdate() {
        // 刷新当前分组的模块列表
        if (this.$refs.moduleList) {
          await this.$refs.moduleList.initTagList()
        }
        this.$emit('update')
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-group-dialog-content {
  background: #ffffff;
  border-radius: 0 0 16px 16px;
  .content{
    border-radius: 0 0 16px 16px;
  }
  .el-loading-parent--relative{
    position: initial!important;
  }
  /deep/ .layout-menu-group-child-dialog {
    .kye-dialog-dynamic {
      min-height: auto !important;
    }
  }
  .layout-move-group-dialog {
    /deep/ .el-dialog {
      border-radius: 16px;
      &__header {
        border-color: #E7EAEC;
      }
      &__footer{
        border-color: #E7EAEC;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/index.vue